module.exports = __webpack_public_path__ + "static/media/gangra.5517ae30.mp3";